var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAttendance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 68H63.5V61.25C63.5 59.45 62.78 57.74 61.52 56.48C60.26 55.22 58.55 54.5 56.75 54.5H47.75C45.95 54.5 44.24 55.22 42.98 56.48C41.72 57.74 41 59.45 41 61.25V68H36.5V61.25C36.5 58.28 37.7 55.4 39.8 53.3C41.9 51.2 44.78 50 47.75 50H56.75C59.72 50 62.6 51.2 64.7 53.3C66.8 55.4 68 58.28 68 61.25V68Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.25 27.5C53.57 27.5 54.89 27.89 56 28.64C57.11 29.39 57.98 30.44 58.49 31.67C59 32.9 59.12 34.25 58.88 35.57C58.61 36.89 57.98 38.09 57.02 39.02C56.09 39.95 54.86 40.61 53.57 40.88C52.25 41.15 50.9 41 49.67 40.49C48.44 39.98 47.39 39.11 46.64 38C45.89 36.89 45.5 35.57 45.5 34.25C45.5 32.45 46.22 30.74 47.48 29.48C48.74 28.22 50.45 27.5 52.25 27.5ZM52.25 23C50.03 23 47.84 23.66 46.01 24.89C44.15 26.12 42.71 27.89 41.87 29.93C41.03 32 40.79 34.25 41.24 36.44C41.66 38.63 42.74 40.64 44.33 42.2C45.89 43.76 47.9 44.84 50.09 45.29C52.28 45.71 54.53 45.5 56.6 44.66C58.67 43.82 60.41 42.38 61.64 40.52C62.87 38.66 63.53 36.5 63.53 34.28C63.53 31.31 62.33 28.43 60.23 26.33C58.13 24.23 55.25 23.03 52.28 23.03L52.25 23Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7301 5.06006C27.8301 5.06006 34.4301 11.6601 34.4301 19.7601C34.4301 27.8601 27.8301 34.4601 19.7301 34.4601C11.6301 34.4601 5.03006 27.8601 5.03006 19.7601C5.03006 11.6601 11.6301 5.06006 19.7301 5.06006ZM19.7301 0.560059C9.14006 0.560059 0.560059 9.14006 0.560059 19.7301C0.560059 30.3201 9.14006 38.9301 19.7601 38.9301C30.3801 38.9301 38.9601 30.3501 38.9601 19.7301C38.9601 9.11006 30.3501 0.560059 19.7301 0.560059Z",
    fill: "#030712"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.14 26.8099L17.87 20.5099V9.04993H21.62V18.9799L26.81 24.1399L24.14 26.8099Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAttendance);
export default __webpack_public_path__ + "static/media/ic-attendance.5c32a5b7fd39c0ee6c1a1974eab020f7.svg";
export { ForwardRef as ReactComponent };